import { Component, type PropsWithChildren } from 'react';
import { SvgIcon } from './components/SvgIcon';
import { registerMainIssue, type SgwtWidgetName } from './monitoring';

type ErrorBoundaryProps = PropsWithChildren & {
  tagName: string;
};

interface State {
  error?: Error;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, State> {
  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { error: undefined };
  }

  public render() {
    const { error } = this.state;
    if (error) {
      const { tagName } = this.props;
      console.error(`Error while rendering the widget ${tagName}:`, error);
      registerMainIssue(tagName as SgwtWidgetName, error);
      return (
        <i className="sgwt-widgets-icon text-warning" title={`The widget <${tagName}> could not be rendered. Please contact the support.`}>
          <SvgIcon type="error" />
        </i>
      );
    }
    return <>{this.props.children}</>;
  }
}
